enum AgentActionType {
    SendEmail = 1,
    NoActionRequired = 5,
}

export default AgentActionType;
